import { useState, useCallback } from 'react'
import { FiCopy } from 'react-icons/fi'
import { RiCheckLine } from 'react-icons/ri'
import { useStores } from 'hooks'
import { trackingScript } from 'config/tracking-code'

export const ManualInstall = () => {
	const {
		assetStore: { asset, getDomainForScripts },
		accountStore: { account, hasFeature }
	} = useStores()

	const [copied, setCopied] = useState(false)

	const hasAccessToServerSideTracking = hasFeature('server_side_tracking')
	const domainForScripts =
		asset && hasAccessToServerSideTracking
			? getDomainForScripts(asset)
			: undefined

	const code =
		account?.id && asset?.id
			? trackingScript(account.id, asset.id, domainForScripts)
			: '< code sample >'

	const handleCopy = useCallback(() => {
		navigator.clipboard.writeText(code)
		setCopied(true)
		setTimeout(() => setCopied(false), 2000)
	}, [code])

	return (
		<div className="flex flex-col gap-5">
			<div>
				<p className="text-[16px] leading-[22px] text-t-checkbox-unactive">
					To install manually, put the following code in the &lt;head&gt;
					section of your website. Make sure it is added to all pages.
				</p>
			</div>

			<div className="bg-bg-plan-fill border border-t-gray-input rounded-[8px] shadow-[0px_1px_2px_0px_rgba(16,24,40,0.05)] h-[154px] overflow-hidden">
				<div className="flex gap-2 items-start px-[14px] py-3 h-full">
					<code className="flex-1 text-[16px] leading-[22px] text-t-desc-gray break-all overflow-auto h-full">
						{code}
					</code>
					<button
						onClick={handleCopy}
						className="shrink-0 w-5 h-5 flex items-center justify-center"
						title="Copy to clipboard"
					>
						{copied ? (
							<RiCheckLine className="w-5 h-5 text-[#0B9055]" />
						) : (
							<FiCopy className="w-5 h-5 text-t-desc-gray hover:text-t-email-blue" />
						)}
					</button>
				</div>
			</div>
		</div>
	)
}
